<template>
  <div class="absolute w-full h-full top-0 left-0 bg-black-transparent flex items-center">
    <div
      class="popup h-6/10 1.5xl:w-6/10 1.8xl:w-5/10 fhd:w-4/10 p-4 mx-auto bg-white flex flex-col items-center classen__rounded relative">
      <button class="self-end pr-5" @click="$emit('cancel')"><i class="fas fa-times text-3xl"></i>
      </button>
      <p class="text-2xl font-bold mb-2">{{ getTranslation('addNewTranslation') }}</p>
      <div class="w-full px-20 overflow-y-auto">
        <div class="grid grid-rows-1 grid-cols-6 gap-1 items-center text-left">
          <p class="mandatory">{{ getTranslation('key') }}:</p>
          <input v-model="translationInputs['key']" type="text"
                 class="bg-gray py-1.5 pl-5 m-2 w-full col-span-5">
        </div>
        <div class="grid grid-rows-1 grid-cols-6 gap-1 items-center text-left"
             v-for="language in languages">
          <p>{{ getTranslation(language.code) }}:</p>
          <input v-model="translationInputs[language.code]" type="text"
                 class="bg-gray py-1.5 pl-5 m-2 w-full col-span-5">
        </div>
      </div>

      <p class="warning" v-if="warning">{{ getTranslation(warning) }}</p>

      <button class="classen__button hover__button mt-5 mb-5 px-3" @click="addTranslation">
        {{ getTranslation('add') }}
      </button>
    </div>
  </div>
</template>

<script>
import getTranslation from "../mixins/getTranslation";
import getPermissions from "../mixins/getPermissions";

export default {
  name: "AddTranslationPopup",

  mixins: [getTranslation, getPermissions],

  props: {},

  data() {
    return {
      translationInputs: [],
      warning: null,
    }
  },

  computed: {
    languages() {
      return this.$dashboardStore.getters.getLanguages;
    },

    translations() {
      return this.$dashboardStore.getters.getTranslations;
    },

    translationKeys() {
      let translationKeys = [];
      this.translations.forEach((translation) => {
        if (!translationKeys.includes(translation.key)) {
          translationKeys.push(translation.key);
        }
      });
      return translationKeys;
    },
  },

  methods: {
    addTranslation() {
      let translationKey = this.translationInputs.key;

      if (translationKey === undefined) {
        this.warning = "keyEmpty";
        return;
      }

      if (translationKey.includes(' ')) {
        this.warning = "keyContainsSpaces";
        return;
      }

      if (this.translationKeys.includes(translationKey)) {
        this.warning = "keyExists";
        return;
      }

      Object.entries(this.translationInputs).forEach(([key, value]) => {
        let language = this.languages.find((language) => language.code === key);
        if (language !== undefined) {
          this.$dashboardStore.dispatch('addTranslation', {
            key: translationKey,
            value: value,
            languageId: language.id
          }).then(() => this.$emit('confirm'))
            .catch(() => {
              this.warning = "somethingWentWrong";
            });
        }
      });
    }
  }
}
</script>

<style scoped>
.mandatory::after {
  color: #E60000;
  content: "*";
}

.warning {
  color: #E60000;
}
</style>
